// Auto generated file, do not manually modify!
// com.hotpads.rentpayment.handler.web.v1.landlord.MarkPaymentAsPaidOfflineWebApiHandler

import type { UseMutationOptions } from '@zg-rentals/react-query5';
import { useMutation } from '@zg-rentals/react-query5';
import { tsClientOptions } from '@zg-rentals/react-query5';
import type { Client } from '@zg-rentals/http-client';
import { MarkPaymentAsPaidOfflineWebApiHandler_markPaymentAsPaidOffline } from '@zg-rentals/ts-rent-payment-client';

import type { MarkPaymentAsPaidOfflineWebApiRequestDto } from '@zg-rentals/ts-rent-payment-client';

export interface MarkPaymentAsPaidOfflineWebApiHandler_markPaymentAsPaidOffline_Args {
  postData: MarkPaymentAsPaidOfflineWebApiRequestDto;
}

export type MarkPaymentAsPaidOfflineWebApiHandler_markPaymentAsPaidOffline_Options = UseMutationOptions<
  void,
  unknown,
  MarkPaymentAsPaidOfflineWebApiHandler_markPaymentAsPaidOffline_Args
>;

/**
 * Mark a recurring rent payment as received offline, on behalf of the landlord
 */
export const useMarkPaymentAsPaidOfflineWebApiHandler_markPaymentAsPaidOffline = ({
  httpClient,
  ...options
}: Omit<MarkPaymentAsPaidOfflineWebApiHandler_markPaymentAsPaidOffline_Options, 'mutationFn'> & {
  httpClient?: Client;
} = {}) => {
  return useMutation({
    ...tsClientOptions.mutationOptions,
    ...options,
    mutationFn: (args: MarkPaymentAsPaidOfflineWebApiHandler_markPaymentAsPaidOffline_Args) =>
      MarkPaymentAsPaidOfflineWebApiHandler_markPaymentAsPaidOffline(args.postData, httpClient),
  });
};
